const mHomeLandingAccess = {
  mHomeLandingAccess: {
    academyAccess: {
      paragraph: 'Personaliza tu logo y color. Administra tus usuarios. Integra autoresponders.',
      title: 'Escribe nombre de Academia'
    },

    billingAccess: {
      paragraph: 'Edita tus datos de facturación para tus ventas. Conecta tus pasarelas de pago.',
      title: 'Configura cómo cobrarás'
    },

    productsAccess: {
      paragraph: 'Configura precios de venta y códigos de descuento. Genera cartas de venta.',
      title: 'Define precios de venta'
    },

    projectsAccess: {
      paragraph: 'Crea contenidos, configura sus días de activación y responde preguntas.',
      title: 'Crea tus Formaciones'
    },

    state: {
      pending: 'Pendiente',
      ready: 'Listo'
    },

    subtitle: {
      initial: 'Crea tu Academia Online en 5 simples pasos',
      done: 'Ya tienes tu Academia Online creada',
      notDone: 'Te falta poco para terminar tu Academia Online'
    },

    title: {
      initial: 'Es muy fácil',
      done: 'Muy buen trabajo',
      notDone: 'Vas muy bien'
    }
  }
}

export default mHomeLandingAccess
